import { type PayloadAction } from '@reduxjs/toolkit';
import { type TargetTab } from '@common/store';
import { type DiagramFilterType } from '@common/store/actions/types';
import { type InstallationId } from '@common/types/brandedTypes';
import { type GraphProfile } from '@common/types/models/GraphProfile';
import {
  type GraphConfiguration,
  type SelectedRegisterDataSeriesGraph,
} from '@common/types/models/SelectedDataPoints';

export interface DiagramFilterState {
  dataPoints: DiagramFilterType;
  parameters: DiagramFilterType;
}

export interface GraphsState {
  selectedRegisterDataSeriesGraphs: Record<InstallationId, SelectedRegisterDataSeriesGraph[]>;
  graphConfiguration: Partial<Record<InstallationId, GraphConfiguration>>;
  userGraphProfiles: Record<string, GraphProfile[]>; // keyed by device type
  globalGraphProfiles: Record<string, GraphProfile[]>; // keyed by device type
  diagramFilter: Record<InstallationId, DiagramFilterState>;
}

export const initialGraphsState: GraphsState = {
  selectedRegisterDataSeriesGraphs: {},
  graphConfiguration: {},
  userGraphProfiles: {},
  globalGraphProfiles: {},
  diagramFilter: {},
};

export interface ColorsStoreState {
  colorPalette: string[];
  colorMapping: Record<string, number>; // User preference for specific datapoints - Map register to palette index
  colorsInUse: Record<string, number>; // Keep track of all currently displayed colors to help distribute palette colors evenly
}

export const initialColorsState: ColorsStoreState = {
  colorPalette: [],
  colorMapping: {},
  colorsInUse: {},
};

export type GraphsStoreState = Record<TargetTab, GraphsState> & Record<'shared', ColorsStoreState>;

export const initialState: GraphsStoreState = {
  shared: initialColorsState,
  diagram: initialGraphsState,
  statistics: initialGraphsState,
};

export type Payload<T> = {
  targetTab: TargetTab;
  data: T;
};

export type GraphsPayloadAction<T> = PayloadAction<Payload<T>>;
